<template>
  <v-btn
    :block="block"
    :tile="tile"
    :text="text"
    :fab="fab"
    :outlined="outlined"
    :icon="icon"
    :rounded="rounded"
    :disabled="disabled"
    :title="title"
    :color="color || defColor"
    :left="left"
    :right="right"
    :to="to"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
import { useAppStore } from "../../store/app";
import { mapState } from "pinia";

export default {
  name: "StyledButton",

  props: ["title", "disabled", "block", "left", "right", "color", "to"],

  computed: {
    ...mapState(useAppStore, {
      outlined: (store) => store.config.buttonStyle.outlined,
      text: (store) => store.config.buttonStyle.text,
      rounded: (store) => store.config.buttonStyle.rounded,
      icon: (store) => store.config.buttonStyle.icon,
      fab: (store) => store.config.buttonStyle.fab,
      tile: (store) => store.config.buttonStyle.tile,
      defColor: (store) => store.config.buttonStyle.color,
    }),
  },
};
</script>
